/* eslint-disable unicorn/consistent-function-scoping */
import { devicesActionNames } from './types';
import { GetDeviceByIdAndTypeParameters, GetDeviceByKey } from '../../services/types';
import Devices from '../../services/devices';
import { AppState, AppThunkDispatch } from '..';
import LastMessageTransmission from '../../services/last-message-transmission';
import { enqueueSnackbarAction } from '../snackbar/actions';
import Homing from '../../services/homing';
import { commandsActionNames } from '../commands/types';
import { searchActionNames } from '../search/types';
import RestrictedAssets from '../../services/restricted-assets';

export const getDeviceByIdAndType =
  (input: GetDeviceByIdAndTypeParameters) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const devices = new Devices(client, envVariables.deviceApiV2BaseUrl);
      const response = await devices.getByIdAndType(input);
      dispatch({ type: devicesActionNames.SET_DEVICE, payload: response });
    };

export const getDeviceByKey =
  (input: GetDeviceByKey) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();

    const devices = new Devices(client, envVariables.deviceApiV2BaseUrl);
    const response = await devices.bulkGetByDeviceKey(input.deviceKey);
    dispatch({
      type: devicesActionNames.SET_DEVICE,
      payload: { ...response, data: response.data[0] },
    });
  };

export const clearDeviceState = () => async (dispatch: AppThunkDispatch) =>
  dispatch({ type: devicesActionNames.SET_DEVICE, payload: null });

export const getDeviceCheckIns =
  (input: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const devices = new Devices(client, envVariables.devicesV1BaseUrl);
    try {
      const response = await devices.getCheckIns(input);
      dispatch({ type: devicesActionNames.SET_CHECK_IN_DETAILS, payload: response.data });
    } catch (error) {
      dispatch({ type: devicesActionNames.SET_CHECK_IN_DETAILS, payload: undefined });
    }
  };

export const getMessageTransmissions =
  (input: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const lastMessageTransmission = new LastMessageTransmission(
      client,
      envVariables.lastMessageTransmission,
    );
    try {
      const response = await lastMessageTransmission.getByDeviceKey(input);
      dispatch({
        type: devicesActionNames.SET_MESSAGE_TRANSMISSION_DETAILS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: devicesActionNames.CLEAR_MESSAGE_TRANSMISSION_DETAILS,
        payload: { deviceKey: input },
      });
    }
  };

export const setIsSuspendedDevice = (value: boolean) => (dispatch: AppThunkDispatch) => {
  dispatch({
    type: devicesActionNames.SET_IS_SUSPENDED_DEVICE,
    payload: value,
  });
};

export const callHomingService =
  (deviceKey: string | null, page?: string, proposedRoute?: string, option?: any) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      dispatch({
        type: devicesActionNames.SET_HOMING_SERVICE_RESPONSE,
        payload: { proposedRoute},
      });
      if (option?.dealer) {
        dispatch({
          type: devicesActionNames.SET_HOMING_SERVICE_RESPONSE,
          payload: { proposedRoute, page, option },
        });
      }
      else if (deviceKey) {
        if (option) {
          if (option?.deviceStatus !== 'disabled' || option?.deviceStatus === null) {
            dispatch({ type: searchActionNames.SET_SELECTED_ENTITY, payload: option });
            dispatch({ type: commandsActionNames.SHOW_DEVICE_CONFIGURATION });
            dispatch({
              type: devicesActionNames.SET_HOMING_SERVICE_RESPONSE,
              payload: { proposedRoute, page, option, error: 200 },
            });
            dispatch(setIsSuspendedDevice(false));
          }
          else {
            dispatch({
              type: devicesActionNames.SET_HOMING_SERVICE_RESPONSE,
              payload: { proposedRoute, page, option, error: 451 },
            });
            dispatch(setIsSuspendedDevice(true));
          }
        }
      }
      else if (option?.telematicsAssetId) { // No Device with VIMS Data
        const proposedRoutePath = encodeURI(proposedRoute || "/transactions");
        if (option) dispatch({ type: searchActionNames.SET_SELECTED_VIMS_ENTITY, payload: option });
        dispatch({ type: commandsActionNames.SHOW_DEVICE_CONFIGURATION });
        dispatch({
          type: devicesActionNames.SET_HOMING_SERVICE_RESPONSE,
          payload: { proposedRoute: proposedRoutePath, page, option},
        });
        dispatch(setIsSuspendedDevice(false));
      }
    };

export const setDeviceRadio = (device: any) => async (dispatch: AppThunkDispatch) => {
  dispatch({ type: devicesActionNames.SET_DEVICE, payload: device });
};

export const getRestrictedStatus =
  (serialNumber: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const restrictedAssets = new RestrictedAssets(client, envVariables.restrictedAssetsV1);
    const response = await restrictedAssets.getRestrictedStatusByAssetSerialNumber(serialNumber);
    if (response.status === 200)
      dispatch({
        type: devicesActionNames.SET_IS_RESTRICTED_DEVICE,
        payload: response.data.isRestricted,
      });
  };
